const PlayerHeroDataPL = [
  {
    name: 'Luka Dončić',
    description:
      'Gwiazda Dallas Mavericks znany ze swoich umiejętności rozgrywania.',
    image: '/Luka Doncic.webp',
  },
  {
    name: 'Kevin Durant',
    description:
      'Mistrz NBA i legenda punktowa obecnie grający w Phoenix Suns.',
    image: '/kevin durant.webp',
  },
  {
    name: 'Jaylen Brown',
    description:
      'Gwiazda Boston Celtics, znany ze swojej atletyczności i gry w obronie.',
    image: '/Jaylen Brown.webp',
  },
];

export default PlayerHeroDataPL;
